// angular import
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// project import
import { AdminComponent } from './demo/layout/admin';
import { EmptyComponent } from './demo/layout/empty/empty.component';
import { GuestComponent } from './demo/layout/front/guest.component';
import { AuthGuard } from './@theme/helpers/auth.guard';
import { HotelComponent } from './demo/layout/hotel/hotel.component';
import LoginComponent from './demo/layout/login/login.component';
import ConfirmComponent from "./demo/layout/confirm/confirm.component";
import { IframeComponent } from './demo/components/iframe/iframe.component';

const routes: Routes = [{
  path: '',
  redirectTo: '/hotel/dash',
  pathMatch: 'full'
},
{
  path: 'hotel',
  component: HotelComponent,
  children: [
    {
      path: '',
      redirectTo: '/hotel/dash',
      pathMatch: 'full'
    }, {
      path: 'dash',
      loadChildren: () => import('./demo/components/dash/dash.module').then(m => m.DashModule)
    }, {
      path: 'calendar',
      loadChildren: () => import('./demo/components/calendar/calendar.module').then(m => m.CalendarModule)
    }, {
      path: 'bedcalendar/:id',
      loadChildren: () => import('./demo/components/bedcalendar/bedcalendar.module').then(m => m.BedCalendarModule)
    }, {
      path: 'bookings',
      loadChildren: () => import('./demo/components/bookings/bookings.module').then(m => m.BookingsModule)
    }, {
      path: 'requests',
      loadChildren: () => import('./demo/components/requests/requests.module').then(m => m.RequestsModule)
    }, {
      path: 'invoices',
      loadChildren: () => import('./demo/components/invoices/invoices.module').then(m => m.InvoicesModule)
    }, {
      path: 'addinvoice/:id',
      loadChildren: () => import('./demo/components/addinvoice/addinvoice.module').then(m => m.AddInvoiceModule)
    }, {
      path: 'addinvoice',
      loadChildren: () => import('./demo/components/addinvoice/addinvoice.module').then(m => m.AddInvoiceModule)
    }, {
      path: 'editinvoice/:id',
      loadChildren: () => import('./demo/components/editinvoice/editinvoice.module').then(m => m.EditInvoiceModule)
    }, {
      path: 'editkorrekt/:id',
      loadChildren: () => import('./demo/components/editinvoice/editinvoice.module').then(m => m.EditInvoiceModule)
    }, {
      path: 'guests',
      loadChildren: () => import('./demo/components/guests/guests.module').then(m => m.GuestsModule)
    }, {
      path: 'administrators',
      loadChildren: () => import('./demo/components/administrators/administrators.module').then(m => m.AdministratorsModule)
    }, {
      path: 'workers',
      loadChildren: () => import('./demo/components/workers/workers.module').then(m => m.WorkersModule)
    }, {
      path: 'information',
      loadChildren: () => import('./demo/components/information/information.module').then(m => m.InformationModule)
    }, {
      path: 'bedtypes',
      loadChildren: () => import('./demo/components/bedtypes/bedtypes.module').then(m => m.BedTypesModule)
    }, {
      path: 'objects',
      loadChildren: () => import('./demo/components/objects/objects.module').then(m => m.ObjectsModule)
    }, {
      path: 'rooms/:id',
      loadChildren: () => import('./demo/components/rooms/rooms.module').then(m => m.RoomsModule)
    }, {
      path: 'addbooking/:clientId',
      loadChildren: () => import('./demo/components/addbooking/addbooking.module').then(m => m.AddBookingModule)
    }, {
      path: 'addbooking',
      loadChildren: () => import('./demo/components/addbooking/addbooking.module').then(m => m.AddBookingModule)
    }, {
      path: 'editbooking/:id',
      loadChildren: () => import('./demo/components/editbooking/editbooking.module').then(m => m.EditBookingModule)
    }]
}, {
  path: 'invoice/:id',
  loadChildren: () => import('./demo/components/invoice/invoice.module').then(m => m.InvoiceModule)
},
{
  path: "iframe/:id",
  loadChildren: () => import('./demo/components/iframe/iframe.module').then(m => m.IframeModule)
},
{
  path: 'check',
  component: ConfirmComponent
},
{
  path: 'login',
  component: LoginComponent
},
{
  path: '',
  component: AdminComponent,
  //canActivate: [AuthGuard],
  children: [
  ]
},
{
  path: '',
  component: EmptyComponent,
  children: [
    {
      path: '',
      redirectTo: '/auth/login',
      pathMatch: 'full'
    }
  ]
},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
